<div class="component-container">
  <div [class.disabled]="disabled" (click)="onClick.emit($event)" (keydown.enter)="onClick.emit($event)" tabindex="0" role="button">
    @if (!model) {
      <label
        for="tickets_uploader"
        class="btn-area"
        [class.w-stretch]="areaMode"
        [class.btn-area]="areaMode"
        [class.btn]="!areaMode"
        [class.btn-primary-outline]="!areaMode"
        [class.has-file]="model"
        >
        @if (areaMode) {
          <span class="text-center">
            @if (!model && !loading) {
              <img src="assets/svg/import_tickets.svg" width="25" height="25" alt="" />
            }
            @if (loading) {
              <i class="pi pi-spin pi-spinner color-primary" style="font-size: 2rem"></i>
            }
            @if (!model && !loading) {
              <span class="btn-area-label">
                <i aria-hidden="true" class="color-primary icon icon-plus"></i>
                @if (label) {
                  <b>{{ label }}</b>
                }
                @if (!label) {
                  <b>{{ importTitle | translate }}</b>
                }
              </span>
            }
          </span>
        }
        @if (!areaMode) {
          @if (loading) {
            <i class="pi pi-spin pi-spinner color-primary" style="font-size: 1rem"></i>
          }
          @if (!loading) {
            <i aria-hidden="true" class="color-primary icon icon-plus"></i>
          }
          {{ importTitle | translate }}
        }
        @if (openTheFileUploadOnClick) {
          <input
            [disabled]="loading || disabled"
            type="file"
            accept=".xlsx"
            class="sr-only"
            (change)="onChange($event)"
            id="tickets_uploader"
            #inputEl
            />
        }
        @if (!openTheFileUploadOnClick) {
          <input [disabled]="loading || disabled" class="sr-only" id="tickets_uploader_btn_only" />
        }
      </label>
    }

    @if (model && !loading && !disabled && !areaMode) {
      <button class="btn btn-primary-outline" (click)="reset($event)">
        <i aria-hidden="true" class="icon icon-trash mr-5"></i>
        {{ 'COMMON.BUTTONS.DELETE_TICKETS' | translate }}
      </button>
    }

    @if (model && areaMode) {
      <div class="img-box btn-area w-stretch" [class.has-file]="model">
        <span class="text-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="25" height="25">
            <path fill="#4CAF50" d="M41,10H25v28h16c0.553,0,1-0.447,1-1V11C42,10.447,41.553,10,41,10z" />
            <path fill="#FFF" d="M32 15H39V18H32zM32 25H39V28H32zM32 30H39V33H32zM32 20H39V23H32zM25 15H30V18H25zM25 25H30V28H25zM25 30H30V33H25zM25 20H30V23H25z" />
            <path fill="#2E7D32" d="M27 42L6 38 6 10 27 6z" />
            <path
              fill="#FFF"
              d="M19.129,31l-2.411-4.561c-0.092-0.171-0.186-0.483-0.284-0.938h-0.037c-0.046,0.215-0.154,0.541-0.324,0.979L13.652,31H9.895l4.462-7.001L10.274,17h3.837l2.001,4.196c0.156,0.331,0.296,0.725,0.42,1.179h0.04c0.078-0.271,0.224-0.68,0.439-1.22L19.237,17h3.515l-4.199,6.939l4.316,7.059h-3.74V31z"
              />
          </svg>
          @if (model && !loading && !disabled) {
            <a href="#" class="btn-area-label" (click)="reset($event)">
              <i aria-hidden="true" class="icon icon-trash mr-5"></i>
              <b>{{ 'COMMON.BUTTONS.DELETE_TICKETS' | translate }}</b>
            </a>
          }
        </span>
      </div>
    }
  </div>
</div>
